import { SxProps } from '@mui/material';

export const CommonStyles = {
  loadingContainer: {
    marginTop: '200px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
} satisfies Record<string, SxProps>;
